import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";


export const getDocumentCategories = createAsyncThunk( //here is doc category
  "documentCategories/getDocumentCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getMethod("/api/getDocumentCategory");
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch categories");
    }
  }
);

const initialState = {
  categories: [],         
  selectedCategory: null,  
  selectedSubCategory: null,
  loading: false,
  error: null,
};

const documentCategorySlice = createSlice({
  name: "documentCategories",
  initialState,
  reducers: {
    resetDocumentCategories: (state) => {
      state.categories = [];
      state.selectedCategory = null;
      state.selectedSubCategory = null;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDocumentCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload?.data || [];
      })
      .addCase(getDocumentCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const {
  resetDocumentCategories
} = documentCategorySlice.actions;

export default documentCategorySlice.reducer;
